import styled, { css } from "styled-components";
import { IStyleProps } from "./interfaces";

export const StyledCard = styled.div`
    height: 126px;
    display: flex;
    overflow: hidden;
`;

export const Image = styled.div<IStyleProps>`
    background-image: url(${p => p.src});
    background-size: cover;
    background-position: center center;
    width: 162px;
    height: 126px;
    ${p =>
        p.small
            ? css`
                  width: 130px;
              `
            : undefined}
`;

export const Ribbon = styled.div`
    width: 10px;
    background-color: ${p => p.theme.c.info};
    z-index: 1;
`;

export const Infos = styled.div<IStyleProps>`
    flex: 1;
    padding: 20px;
    font-weight: 300;
    ${p =>
        !p.small
            ? css`
                  padding-right: 0;
              `
            : undefined}
`;

export const Name = styled.div`
    font-size: 18px;
    margin-bottom: 8px;
    max-width: 194px;
`;

export const Details = styled.div`
    font-size: 14px;
    margin-bottom: 12px;
`;
